// get
export const isAuthenticated = () => !!localStorage.getItem('token');
export const getUser = () => JSON.parse(localStorage.getItem('currentUser'));
export const getToken = () => localStorage.getItem('token') || null;
export const getItem = (key) => localStorage.getItem(`${key}`) || null;

// remove
export const removeItemByKeyFromLocalStroage = (key) => {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
  }
};
